export default {
    'add': '\ue60f',
    'close': '\ue617',
    'close-o': '\ue620',
    'commet': '\ue683',
    'date': '\ue651',
    'decrease': '\ue6b5',
    'del-circle': '\ue620',
    'edit': '\ue6e4',
    'home': '\ue611',
    'increase': '\ue6b6',
    'loading': '\ue63e',
    'member': '\ue64a',
    'members': '\ue618',
    'photo': '\ue686',
    'right-arrow': '\ue616',
    'text': '\ue688',
    'time': '\ue655',
    'unchecked': '\ue61e',
    'checked': '\ue623',
    'selected': '\ue61f',
    'search': '\ue610'
}
  


// WEBPACK FOOTER //
// ./src/components/Icon/type.js